export default (namespace) => ({
  propertyArea: {
    id: `${namespace}.propertyArea`,
    defaultMessage: 'area',
  },
});
